import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  MarketRow,
  MarketAccessory,
  MarketPopover,
  MarketActivityIndicator,
} from '@market/react';
import CardLogo from 'components/pages/checkout/payment/saved_cards/card_logo';
import trashCan from 'images/icons/trashcan.svg';

import marketRowStyles from 'components/pages/checkout/payment/saved_cards/saved_cards_dropdown.module.scss';

export const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

const SavedCardsDropdown = ({
  topPosition = 0,
  leftPosition = 0,
  open = false,
  deletionInProgress = false,
  savedCards = [],
  onCardSelected,
  onCardDeleted,
}) => {
  if (savedCards.length === 0 || !open) {
    return null;
  }

  const styles = {
    position: 'absolute',
    top: `${topPosition}px`,
    left: `${leftPosition}px`,
    width: '100%',
    zIndex: 2,
  };

  const { t } = useTranslation();

  return (
    <MarketPopover style={styles} data-testid="saved-cards-dropdown">
      <h3>{t('checkout.payment.savedCardsDropdown.title')}</h3>
      {deletionInProgress && (
        <MarketActivityIndicator
          data-testid="activity-indicator"
          size="small"
          style={{ position: 'absolute', top: '50%', left: '50%' }}
        />
      )}
      {!deletionInProgress &&
        savedCards.map((savedCard) => (
          <MarketRow
            onClick={() => {
              onCardSelected(savedCard.id);
            }}
            key={savedCard.id}
            value={savedCard.id}
            data-testid={`saved-card-${savedCard.id}`}
            className={marketRowStyles.savedCard}
          >
            <label slot="label">
              {capitalize(savedCard.payment_source.brand)} ••••{' '}
              {savedCard.payment_source.last_digits}
            </label>
            {savedCard.default && (
              <p slot="subtext">
                {t('checkout.payment.savedCardsDropdown.default')}
              </p>
            )}

            <MarketAccessory size="image" slot="leading-accessory">
              <CardLogo brand={savedCard.payment_source.brand} />
            </MarketAccessory>
            <MarketAccessory size="image" slot="trailing-accessory">
              <img
                data-testid={`delete-saved-card-${savedCard.id}`}
                style={{ height: '24px', width: '24px' }}
                src={trashCan}
                alt={t('checkout.payment.savedCardsDropdown.deleteCard')}
                onClick={(event) => {
                  event.stopPropagation();
                  onCardDeleted(savedCard.id);
                }}
              />
            </MarketAccessory>
          </MarketRow>
        ))}
    </MarketPopover>
  );
};

export default SavedCardsDropdown;
